var _a;
import { useMemo } from 'react';
import { addWeeks, addMonths } from 'date-fns';
import { plannedFollowUpOfMedManagementEngagementWithClient } from 'constants/ehrNoteEnums';
export var plannedFollowUpParsers = (_a = {},
    _a[plannedFollowUpOfMedManagementEngagementWithClient.inOneWeek] = function (date) { return addWeeks(date, 1); },
    _a[plannedFollowUpOfMedManagementEngagementWithClient.inTwoWeeks] = function (date) {
        return addWeeks(date, 2);
    },
    _a[plannedFollowUpOfMedManagementEngagementWithClient.inOneMonth] = function (date) {
        return addMonths(date, 1);
    },
    _a[plannedFollowUpOfMedManagementEngagementWithClient.inTwoMonths] = function (date) {
        return addMonths(date, 2);
    },
    _a[plannedFollowUpOfMedManagementEngagementWithClient.inThreeMonths] = function (date) {
        return addMonths(date, 3);
    },
    _a[plannedFollowUpOfMedManagementEngagementWithClient.inSixMonths] = function (date) {
        return addMonths(date, 6);
    },
    _a[plannedFollowUpOfMedManagementEngagementWithClient.notApplicable] = function (date) { return date; },
    _a);
export var usePlannedFollowUpNextDate = function (lastAppointmentDate, plannedFollowUp) {
    var plannedFollowUpDate = useMemo(function () {
        if (!lastAppointmentDate || !plannedFollowUp)
            return null;
        var appointmentDate = new Date(lastAppointmentDate);
        return plannedFollowUpParsers[plannedFollowUp](appointmentDate);
    }, [lastAppointmentDate, plannedFollowUp]);
    return plannedFollowUpDate;
};
